module.exports = __webpack_public_path__ + "img/d8cf24b4-caf7-4ddd-a9e3-5f8504bc2b3b.859b100e.png";